import styled from 'styled-components';

import { Button } from '@dreryk/react-components';

export const StyledEwusPatientDownloadButton = styled(Button)`
   align-self: flex-start;
`;
